// Activity types the lead timeline can render; anything else falls back to 'note'
export const LEAD_ACTIVITY_TYPES = [
  'call',
  'email',
  'meeting',
  'note',
  'chat',
  'sms',
  'form',
  'booking',
  'inbox_reply',
] as const

export type LeadActivityType = (typeof LEAD_ACTIVITY_TYPES)[number]
